angular.module("ainapp")
    .controller("ViewTicketController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.init = function () {

                $scope.load = true;
                $scope.VoucherData = {};

                if ($stateParams.VoucherId > 0) {

                    MainService.getTicketbyId($stateParams.VoucherId).then(function (response) {
                        if (response.data) {
                            $scope.VoucherData = response.data[0];
                        }
                        $scope.load = false;
                    }, function (err) {
                        $scope.load = false;
                        toastr.error("NetworkError");
                    })
                }

            }

            $scope.init();

 }])
